import React, { useState } from "react";
import { Form, Button, Card, Alert, Container, Row, Col, InputGroup } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import loginGif from "../Assets/login-security.gif";
import "./Login.css";
import { FiMail, FiLock } from "react-icons/fi";

const Login = () => {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    try {
      await login(email, password);
      navigate("/");
    } catch (err) {
      setError("Invalid email or password");
    }
  };

  return (
    <Container fluid className="login-page">
      <Row className="justify-content-center align-items-center g-0 login-row">
        <Col xs={12} md={6} className="d-flex justify-content-center align-items-center login-visual order-1">
          <img src={loginGif} alt="Secure Login" className="login-gif" />
        </Col>
        <Col xs={12} md={6} className="p-4 p-md-5 order-2">
          <Card className="shadow-sm border-0 login-card">
            <Card.Body className="p-4 p-md-5">
              <h1 className="login-title mb-2">Log in!</h1>
              <p className="login-subtitle mb-4">Explore, learn, and grow with us. Enjoy a seamless and enriching journey—let's begin!</p>
              {error && <Alert variant="danger">{error}</Alert>}
              <Form onSubmit={handleSubmit}>
                <Form.Group className="mb-3">
                  <Form.Label>Your email</Form.Label>
                  <InputGroup>
                    <InputGroup.Text><FiMail /></InputGroup.Text>
                    <Form.Control type="email" placeholder="Enter your email" value={email} onChange={(e) => setEmail(e.target.value)} required />
                  </InputGroup>
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>Password</Form.Label>
                  <InputGroup>
                    <InputGroup.Text><FiLock /></InputGroup.Text>
                    <Form.Control type="password" placeholder="Enter your password" value={password} onChange={(e) => setPassword(e.target.value)} required />
                  </InputGroup>
                </Form.Group>
                <Button type="submit" className="w-100 login-btn">Log in</Button>
              </Form>
              <div className="d-flex justify-content-between mt-2">
                <span />
                <Button variant="link" className="p-0" onClick={() => navigate('/forgot-password')}>Forgot Password?</Button>
              </div>
              <div className="text-center mt-3">
                Don’t have an account? <Link to="/register">Sign up</Link>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};
export default Login;
